import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export function useDomains() {
  return useQuery({
    queryKey: ['domains'],
    queryFn: api.listDomains,
    refetchInterval: 10_000,
  })
}

export function useCreateDomain() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { fqdn: string; service_id?: number; ttl?: number; redirect_to?: string; auth_token?: string }) =>
      api.createDomain(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['domains'] })
    },
  })
}

export function useDeleteDomain() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.deleteDomain(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['domains'] })
    },
  })
}

export function useUpdateDomain() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: { service_id?: number | null; redirect_to?: string; auth_token?: string } }) =>
      api.updateDomain(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['domains'] })
    },
  })
}

export function useRefreshDomain() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.refreshDomain(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['domains'] })
    },
  })
}
